import type { FC } from 'react';

import logoImg from 'assets/logo.svg';

import { BuildBackgroundContainer, Logo } from './BuildBackground.styled.ts';
import type { BuildBackgroundProps } from './BuildBackground.types.ts';

const BuildBackground: FC<BuildBackgroundProps> = ({ showLogo, children }) => {
  return (
    <BuildBackgroundContainer>
      {children}

      {showLogo && <Logo src={logoImg} alt="logo" />}
    </BuildBackgroundContainer>
  );
};

export default BuildBackground;
